const mediaImageMapper = item => ({
  title: item?.entity?.title,
  image: item?.entity?.media?.entity?.fieldMediaImage || {},
  gImage:
    item?.entity?.media?.entity?.gatsbyImageFile?.childImageSharp?.gatsbyImageData,
})

export default mediaImageMapper
